import Layout from '@layout/Index'

export const imgFlowOrder = [
  {
    path: '/img-flow-order',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "img-flow-order-table" */ './pages/ImgFlowOrderTable.vue'),
        name: '图片流转工单列表',
        meta: {
          title: '图片流转工单列表',
        },
      },
      // {
      //   path: 'create',
      //   component: () => import(/* webpackChunkName: "img-flow-order-form" */ './pages/ImgFlowOrderForm.vue'),
      //   name: '添加图片流转工单',
      // },
      // {
      //   path: 'update/:id',
      //   component: () => import(/* webpackChunkName: "img-flow-order-form" */ './pages/ImgFlowOrderForm.vue'),
      //   name: '修改图片流转工单',
      // },
      // {
      //   path: 'detail/:id',
      //   component: () => import(/* webpackChunkName: "img-flow-order-detail" */ './pages/ImgFlowOrderDetail.vue'),
      //   name: '图片流转工单详情',
      // },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/img-flow-order/img-flow-order.route.js